import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-connection-step-b',
  templateUrl: './connection-step-b.component.html',
  styleUrls: ['./connection-step-b.component.scss']
})
export class ConnectionStepBComponent implements OnInit {
  @Input() error: string;
  @Output() register = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  tryRegister() {
    this.register.emit({});
  }

}
